import VideoSectionsSplitConfig from './VideoSectionsSplitConfig';
import GeneralSettings from './GeneralSettings';

//mui imports====
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';

import GeneralTab from '../../../../Components/GeneralTabAndTabContent/index.jsx';

import PageLevelSettings from './PageLevelSettings';
import ExperimentsContextSettings from './ExperimentsContextSettings';
import TpVastConfigTab from './TpVastConfig/index';
import ChangeLogs from './ChangeLogs/index';

//===============

const tabListAndPanels = [
	{
		tab: <Tab label="General Settings" value="SITE_CONFIG.GENERAL" key="SITE_CONFIG.GENERAL" />,
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.GENERAL"
				key="SITE_CONFIG.GENERAL"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<GeneralSettings />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Split Config Settings"
				value="SITE_CONFIG.SPLIT_CONFIG"
				key="SITE_CONFIG.SPLIT_CONFIG"
			/>
		),
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.SPLIT_CONFIG"
				key="SITE_CONFIG.SPLIT_CONFIG"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<VideoSectionsSplitConfig />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Page Level Settings"
				value="SITE_CONFIG.PAGE_PLAYLIST_CONFIG"
				key="SITE_CONFIG.PAGE_PLAYLIST_CONFIG"
			/>
		),
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.PAGE_PLAYLIST_CONFIG"
				key="SITE_CONFIG.PAGE_PLAYLIST_CONFIG"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<PageLevelSettings />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="Experiments Context"
				value="SITE_CONFIG.EXPERIMENTS_CONTEXT"
				key="SITE_CONFIG.EXPERIMENTS_CONTEXT"
			/>
		),
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.EXPERIMENTS_CONTEXT"
				key="SITE_CONFIG.EXPERIMENTS_CONTEXT"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<ExperimentsContextSettings />
			</TabPanel>
		)
	},
	{
		tab: (
			<Tab
				label="TP Vast Config"
				value="SITE_CONFIG.TP_VAST_CONFIG"
				key="SITE_CONFIG.TP_VAST_CONFIG"
			/>
		),
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.TP_VAST_CONFIG"
				key="SITE_CONFIG.TP_VAST_CONFIG"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<TpVastConfigTab />
			</TabPanel>
		)
	},
	{
		tab: <Tab label="Change Logs" value="SITE_CONFIG.CHANGE_LOGS" key="SITE_CONFIG.CHANGE_LOGS" />,
		tabPanel: (
			<TabPanel
				value="SITE_CONFIG.CHANGE_LOGS"
				key="SITE_CONFIG.CHANGE_LOGS"
				sx={{ padding: 0, marginTop: '1.5rem' }}
			>
				<ChangeLogs />
			</TabPanel>
		)
	}
];

const SiteConfig = () => {
	return (
		<GeneralTab
			tabListAndPanels={tabListAndPanels}
			tabListStyles={{ width: 'fit-content', marginLeft: '3rem' }}
			tabListProps={{
				variant: 'scrollable',
				visibleScrollbar: true,
				scrollButtons: 'auto',
				sx: {
					'& .MuiTabs-scrollableX': {
						'&::-webkit-scrollbar': {
							height: '10px'
						}
					}
				}
			}}
		/>
	);
};

export default SiteConfig;
